
import { ISearchLimitOffset } from './ISearchLimitOffset';

export interface IFilterMarque extends ISearchLimitOffset {
  SocieteIds?: number [];
  SortField?: string;
  IsDescending?:boolean;
  }

 
  export const getDefaultFilterMarque = (): IFilterMarque => ({
    SocieteIds:undefined,
    SortField: "",
    IsDescending: true,
    Offset: 0,
    Limit: 10,
  });

  export const dtoToFilter = (dto: IFilterMarque): IFilterMarque => {
  
    return {
      SocieteIds: dto.SocieteIds,
      IsDescending: dto.IsDescending !== undefined ? dto.IsDescending : false,
      Limit: dto.Limit !== undefined ? dto.Limit : 10,
      Offset: dto.Offset !== undefined ? dto.Offset : 0,
      SortField: dto.SortField,
  };
}
  export const filterToQuery = (filter: IFilterMarque): IFilterMarque => {
    const dto: IFilterMarque = {};
 
    if (filter?.SocieteIds !== undefined ) {
      dto.SocieteIds = filter.SocieteIds;
    } 

    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 100;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }

    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }


    localStorage.setItem("IFilterMarques", JSON.stringify(dto));
  
    return dto;
  };
  
  
   